import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-secondary)";

function IconChatHistory({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.78 1.052a5.002 5.002 0 0 1 5.275 7.01 5.001 5.001 0 0 1-8.748.665.501.501 0 0 1 .84-.546 4.001 4.001 0 0 0 6.996-.531A4.002 4.002 0 0 0 8.654 2.63a4.001 4.001 0 0 0-5.18.752 4 4 0 0 0-.853 1.643l.8-.696a.5.5 0 1 1 .656.755L2.854 6.15a1 1 0 0 1-1.41-.098L.38 4.827a.5.5 0 1 1 .754-.656l.521.598A4.998 4.998 0 0 1 5.78 1.052z" fill={fill}/>
            <path d="M5.9 3.5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1H6a.6.6 0 0 1-.6-.6V4a.5.5 0 0 1 .5-.5z" fill={fill}/>
        </svg>

    );
}

export default IconChatHistory;

